import React from "react"
import { motion } from "framer-motion"
import { Ban, AlertTriangle, SearchX } from "lucide-react"
import { ReportCard } from "./ReportUI"
import { REPORT_COLORS } from "./reportTheme"

const FullPageState = ({ icon: Icon, title, description, spinner }) => (
  <div style={{ minHeight: "60vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
    <ReportCard style={{ textAlign: "center", padding: "48px 32px", maxWidth: 420 }}>
      {spinner ? (
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 0.9, ease: "linear" }}
          style={{
            width: 32,
            height: 32,
            margin: "0 auto 16px",
            borderRadius: "50%",
            border: `3px solid ${REPORT_COLORS.cardBorder}`,
            borderTopColor: REPORT_COLORS.accent,
          }}
        />
      ) : (
        Icon && <Icon size={32} color={REPORT_COLORS.textMuted} style={{ marginBottom: 16, opacity: 0.7 }} />
      )}
      <div style={{ color: REPORT_COLORS.textPrimary, fontWeight: 700, fontSize: 18, marginBottom: 8 }}>{title}</div>
      {description && <div style={{ color: REPORT_COLORS.textMuted, fontSize: 14 }}>{description}</div>}
    </ReportCard>
  </div>
)

export const ProcessingState = () => (
  <FullPageState
    spinner
    title="Building this report"
    description="This can take a couple of minutes the first time a report is shared. This page will update automatically — no need to refresh."
  />
)

export const DisabledState = () => (
  <FullPageState
    icon={Ban}
    title="This report link has been disabled"
    description="Ask whoever shared this link with you for a new one."
  />
)

export const NotFoundState = () => (
  <FullPageState
    icon={SearchX}
    title="This report link is not valid"
    description="Double-check the link, or ask whoever shared it with you for a current one."
  />
)

export const FailedState = () => (
  <FullPageState
    icon={AlertTriangle}
    title="This report couldn't be built"
    description="Something went wrong while generating this report. Please check back later."
  />
)
